// Get Staff Constants
export const GET_VISITS_REQUEST = 'GET_VISITS_REQUEST';
export const GET_VISITS_SUCCESS = 'GET_VISITS_SUCCESS';
export const GET_VISITS_FAILURE = 'GET_VISITS_FAILURE';
